



































































import { defineComponent, reactive, computed, ref, watch, onUnmounted } from '@vue/composition-api';
import { ChevronLeftIcon, JumpIcon } from 'tdesign-icons-vue';
import { DialogPlugin, DialogInstance } from 'tdesign-vue';

// 引入 components
import UserLogo from '@/renderer/components/user/components/UserLogo.vue';
import PasswordForm from '@/renderer/components/user/components/passwordForm.vue';
import AgreementCheckbox, { AgreementComponent } from '@/renderer/components/Base/Agreement/AgreementCheckbox.vue';

// 引入 composition
import userValidator from '@/renderer/components/user/compositions/userValidator';
import passwordHandler from '@/renderer/components/user/compositions/passwordHandler';

// 引入工具类
import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import phonePrefixOptions from '@/renderer/scripts/utils/phonePrefix';
import store from '@/renderer/store/index';
import user, { User } from '@/renderer/scripts/utils/user';
import { loginWithPassword } from '@/renderer/scripts/utils/user/userLogin';
import { getDeviceName } from '@/renderer/scripts/utils/tools';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

export default defineComponent({
  components: {
    ChevronLeftIcon,
    JumpIcon,
    UserLogo,
    PasswordForm,
    AgreementCheckbox,
  },
  props: {
    vistorLogin: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = context.root;
    const formData = reactive({
      corpId: '',
      loginAccount: '',
      loginPassword: '',
      code: '',
    });
    const resetFormData = reactive({
      password: '',
      cfmPassword: '',
    });
    const { rules } = userValidator(formData);
    const { corpList, getCorpList, updatePassword } = passwordHandler();
    const showAgreementPopup = ref(false);
    const confirmValidated = computed(() => {
      return formData.loginAccount && formData.loginPassword;
    });
    const needResetPwd = ref(false);
    const userBaseInfo = reactive({
      userNickname: '',
      avatar: '',
    });
    const agreementRef = ref<AgreementComponent | null>(null);

    const methods = {
      forgetPassword() {
        const dialog: DialogInstance = CustomDialog.confirm({
          theme: 'info',
          header: i18n_t('请联系超级管理员重置密码'),
          width: '400px',
          cancelBtn: null,
          async onConfirm() {
            if (dialog?.hide) {
              dialog.hide();
            }
          },
        });
      },
      // 登录
      async confirmToLogin() {
        // 登录时需要选中已读协议
        if (!agreementRef.value?.validate()) {
          return;
        }
        tips.loading(i18n_t('正在登录'), 0);
        const loginParams = {
          accountName: formData.loginAccount,
          password: formData.loginPassword,
          deviceId: getDeviceName(),
          corpId: formData.corpId,
          ...(!store.getters.isPrivate && {
            domain: CONSTANT_URL.currentDomain,
          }),
        };
        await loginWithPassword(loginParams);
      },
      // 点击登录/绑定手机号按钮
      async onSubmit(): Promise<void> {
        if (!confirmValidated.value) return;
        user.setLoginType(User.LoginTypeKey.loginWithPassword);
        methods.confirmToLogin();
      },
      // 需要强制修改密码
      showResetPassword(orgUser: SMH.OrgUser) {
        tips.closeAll();
        needResetPwd.value = true;
        Object.assign(userBaseInfo, orgUser);
        context.emit('need-reset-password');
      },
      async onReset(params: CoFile.EditUserPassword) {
        const res = await updatePassword({
          originalAccountPassword: formData.loginPassword,
          accountPassword: params.newPassword,
        });
        if (res) {
          user.setNeedChangePassword(false);
          user.onLogined();
        }
      },
      // 取消重置
      cancelReset() {
        Object.assign(resetFormData, {
          password: '',
          cfmPassword: '',
        });
        needResetPwd.value = false;
        context.emit('cancel-reset-password');
      },
      validate() {
        return agreementRef.value?.validate();
      },
    };

    // 企业级唯一时需要查询组织机构
    if (store.getters.selectOrgBeforeLogin) {
      getCorpList();
    }

    watch(
      () => corpList.value,
      val => {
        if (val && val.length) {
          formData.corpId = val[0].corpId;
        } else {
          formData.corpId = '';
        }
      },
    );
    user.on('reset-password', methods.showResetPassword);
    onUnmounted(() => {
      user.off('reset-password', methods.showResetPassword);
    });
    return {
      agreementRef,
      phonePrefixOptions,
      needResetPwd,
      userBaseInfo,
      rules,
      showAgreementPopup,
      confirmValidated,
      corpList,
      formData,
      resetFormData,
      ...methods,
    };
  },
});
